

import React from 'react';

import { AuthorisationConsumer } from '../../AuthorisationWrapper';
import withPublicLink from '../../WithPublicLink';
import RequestProvider from '../../RequestProvider';
import { getOrganisationQuery, getUserTeamsQuery, getContractBalanceQuery } from '../../../common/api';
import { getFinanceBalance as getFinanceBalanceQuery } from '@core/shared/api/financeApi';
import CreditsProvider from '../components/CreditsProvider';
import getTeamsQuery from '../../../common/api/getTeams';





function Credits({ children }) {
  return (
    <AuthorisationConsumer>
      {({
        selectedOrganisation: { organisationId, permissions } = {},
        isShootstaAdmin,
        isShootstaTechSupport
      }) =>
      <RequestProvider
        requests={{
          getOrganisation: getOrganisationQuery(organisationId),
          getUserTeams: getUserTeamsQuery(organisationId),
          getContractBalance: getContractBalanceQuery(),
          getTeams: getTeamsQuery(organisationId),
          getFinanceBalance: getFinanceBalanceQuery(organisationId, { silent: true })
        }}>

          {({ getOrganisation, getUserTeams, getContractBalance, getTeams, getFinanceBalance }) =>
        <CreditsProvider
          organisationId={organisationId}
          getOrganisation={getOrganisation}
          getUserTeams={getUserTeams}
          getContractBalance={getContractBalance}
          getTeams={getTeams}
          getFinanceBalance={getFinanceBalance}
          hasAdminRole={permissions.includes('MANAGE_ORGANISATION') ||
          isShootstaAdmin ||
          isShootstaTechSupport}>


              {children}
            </CreditsProvider>}

        </RequestProvider>}

    </AuthorisationConsumer>);

}

export default withPublicLink(Credits);